export default __webpack_public_path__ + "dist/media/ResendRed.79a91064.svg";